import gql from 'graphql-tag';

export const HAS_ACCESS_TO_COBALT_REPORT = gql`
  query CobaltIntelligenceHasAccess {
    cobaltIntelligence {
      result: hasAccess {
        entity
        error
        success
      }
    }
  }
`;
